import React from 'react';
import { getErrorHash } from '@jira/platform__error-reporting/src/getErrorHash.tsx';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics-component';
import { CodeBlockWithCopyButton } from '../code-block-with-actions/CodeBlockWithCopyButton.tsx';

export const ErrorHashAndTraceId = ({
	error,
	traceId,
}: {
	error: Error;
	traceId: string;
}): React.JSX.Element => {
	const errorHash = getErrorHash(error);
	const source = `Hash ${errorHash}\nTrace ${traceId}`;

	return (
		<>
			<FireOperationalAnalytics
				action="rendered"
				actionSubject="errorHashAndTraceId"
				attributes={{
					errorHash,
					traceId,
				}}
			/>
			<div role="note">
				<CodeBlockWithCopyButton
					source={source}
					copyCodeActionSubjectId="copyErrorHashAndTraceId"
				/>
			</div>
		</>
	);
};
